module.exports = __webpack_public_path__ + "media/src/assets/images/campaign-testimonial-d807a9205c4dc805a378888ef03fc0b8.svg";